import React from "react";
import './FooterAllHref.css';

import ChangeLink from "../../../ChangeLink/ChangeLink";
import MainMenuArray from "../../HeaderAll/MainMenu/MainMenuArray";

function  FooterAllHref(props){
        function ListItem(props) {
            const MainMenuArrMenu = props.MenuItem.map((MenuItemElement,index) =>
                <div key={index} className={"FooterAllHrefSubMenuElement FooterAllHrefSubMenuElement"+(index+1) }>
                    <ChangeLink lang={props.lang} activeClassName="FooterAllHrefSubMenuElementActive" to={MenuItemElement.href}>
                       <div/>{MenuItemElement.Name[props.lang]}
                    </ChangeLink>
                </div>
            );
            // Correct! There is no need to specify the key here:
            return (<div className="FooterAllHrefElementMenu">{MainMenuArrMenu}</div>)
        }

        const allFooterHref = MainMenuArray.map((MainMenuArrElement,index) =>
            <div key={index} className={"FooterAllHrefElement FooterAllHrefElement"+index}>
                <div className="FooterAllHrefElementTitle">{MainMenuArrElement.Name[props.lang]}</div>
                    <ListItem MenuItem={MainMenuArrElement.Submenu} lang={props.lang}/>
            </div>);

        return (
            <div className={"FooterAllHref " + (props.in404 ? 'Footer404' : '')}>
                    {allFooterHref}
            </div>
        )}

export default FooterAllHref